import React, { useState } from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Dialog,
  Fab,
  IconButton,
  InputAdornment,
  Slide,
  TextField,
  Toolbar,
  Typography,
  debounce,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Add, Close, Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { LoadingBox } from "../../../../../components/utils";

import SyndicatesTable from "./components/SyndicatesTable";
import { SyndicatesDialog } from "./components/SyndicatesDialog";

import { getSyndicates, getSyndicate } from "../../../../services/pwsApi";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "primary",
    backgroundColor: "rgba(0, 0, 0, 0.25) !important",
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(10),
    right: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Syndicates() {
  const classes = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();

  const companyCode = searchParams.get("company_code");
  const syndicateId = searchParams.get("syndicate_id");

  const tablePageIndex = Number(searchParams.get("page") ?? 1);
  const tablePageSize = Number(searchParams.get("page_size") ?? 50);

  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const syndicatesQuery = useQuery(
    ["syndicates", companyCode, tablePageIndex, tablePageSize, searchQuery],
    () =>
      getSyndicates(
        companyCode.slice(0, 3),
        companyCode.slice(3, 7),
        searchQuery,
        {
          page: tablePageIndex,
          perPage: tablePageSize,
        },
      ),
    {
      enabled: !!companyCode,
    },
  );

  const syndicateQuery = useQuery(
    ["syndicate", syndicateId],
    () =>
      getSyndicate(
        companyCode.slice(0, 3),
        companyCode.slice(3, 7),
        syndicateId,
      ),
    {
      enabled: !!syndicateId,
      onSuccess: () => setDialogOpen(true),
    },
  );

  let syndicate = syndicateQuery.data?.data?.data;
  syndicate = syndicate
    ? {
        syndicateId: syndicate.RCE_CODIGO,
        cnpj: syndicate.RCE_CGC,
        syndicateName: syndicate.RCE_DESCRI,
        entityCOD: syndicate.RCE_CODIGO,
        zipCode: syndicate.RCE_CEP,
        address: syndicate.RCE_ENDER,
        addressNumber: syndicate.RCE_NUMER,
        addressComplement: syndicate.RCE_COMPLE,
        addressNeighborhood: syndicate.RCE_BAIRRO,
        addressState: syndicate.RCE_UF,
        addressCity: syndicate.RCE_MUNIC,
        email: syndicate.RCE_EMAIL,
        phone: syndicate.RCE_FONE,
        cellphone: syndicate.RCE_FAX,
      }
    : null;

  const handleCloseDialog = () => {
    searchParams.delete("screen");
    setSearchParams(searchParams);
  };

  const handleCloseSyndicateDialog = () => {
    searchParams.delete("syndicate_id");
    setSearchParams(searchParams);
    setDialogOpen(false);
  };

  const handleCreateSyndicate = () => {
    setDialogOpen(true);
  };

  const searchDelayed = debounce(query => {
    setSearchQuery(query);
  }, 1000);

  const syndicates = syndicatesQuery?.data?.data?.data ?? [];
  const rows = syndicatesQuery?.data?.data?.meta?.total ?? 0;

  return (
    <Dialog
      fullScreen
      open
      onClose={handleCloseDialog}
      TransitionComponent={Transition}
    >
      {dialogOpen && (
        <SyndicatesDialog
          onClose={handleCloseSyndicateDialog}
          data={syndicate}
        />
      )}

      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleCloseDialog}>
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Sindicatos
          </Typography>
        </Toolbar>
      </AppBar>

      <Backdrop
        className={classes.backdrop}
        open={syndicatesQuery.isLoading || false}
      >
        <LoadingBox />
      </Backdrop>

      <Box sx={{ height: "calc(100% - 94px)", padding: "15px" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <TextField
            style={{ width: "400px" }}
            label="Pesquisar"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={event => {
              searchDelayed(event.target.value);
            }}
          />
        </Box>

        <SyndicatesTable data={syndicates} rows={rows} />
      </Box>

      {/* <Fab
        color="primary"
        aria-label="add"
        className={classes.fab}
        onClick={handleCreateSyndicate}
      >
        <Add />
      </Fab> */}
    </Dialog>
  );
}
